import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import useCallApi from '../../hooks/useCallApi';
import Loading from './Loading';
import ReactTooltip from 'react-tooltip';

const InputSelect = ({ label, field = '', id, value = '', textFormatter = undefined, dataProvider = [], onChange = () => '', required = true, readOnly = false, containBlank = false, info = '' }) => {

    const { data, loading } = useCallApi(dataProvider);

    const sinAsignar = [{ value: '', text: 'Seleccione' }];

    const dataMatch = [...sinAsignar, ...data];

    const result = containBlank ? dataMatch : data;

    return (
        <div className="sg-input mt-15">
            <label htmlFor={id}>{label}
                {
                    info != '' && <FaInfoCircle color="#E1E1E1" data-tip={info} />
                }
            </label>
            {loading ?
                <Loading /> :
                <select name={field} className="sg-input-select" id={id} onChange={onChange} value={value} required={required} disabled={readOnly}>
                    {data && result.map((item, i) => <option key={i} value={item.value}>{textFormatter != undefined ? textFormatter(item) : item.text}</option>)}
                </select>
            }
        </div>
    );
}



export default InputSelect;
